<template>
    <div class="page-content">
        <div class="center-head">
            <div class="center-head-content">
                <img class="user-head" :src="`/api/v1/file/${userInfo.detail.portrait}`" alt="">
                <div>
                    <div class="nick-name">{{timeStr}}，{{userInfo.detail.nickname}}</div>
                    <div class="tag-content">
                        <div class="mr-10" v-if="userInfo.is_landlord>0">房东</div>
                        <div class="mr-10" v-if="userInfo.is_driver>0">导游</div>
                        <div class="mr-10" v-if="userInfo.is_landlord===0&&userInfo.is_driver===0">普通会员</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="center-content">
            <div class="center-menu">
                <el-menu router
                         :default-active="$route.path"
                        class="el-menu-vertical-demo">
                    <el-submenu v-for="(item,index) in menuList" :key="index" :index="`${index}`">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span>{{item.name}}</span>
                        </template>
                        <el-menu-item v-for="(it, i) in item.children" :key="i" :index="it.path">{{it.name}}</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
            <router-view class="router-view-content"></router-view>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "index",
        data() {
            return {
                timeStr: '',
                userManage: [
                    {name: '个人资料', path: '/center/userCenter'},
                    {name: '消息中心', path: '/center/msgCenter'},
                    {name: '收藏管理', path: '/center/collection'},
                    {name: '我发布的需求', path: '/center/myNeeder'},
                ],
                landlord: [
                    {name: '房东订单', path: '/center/landlordOrder'},
                    {name: '房源管理', path: '/center/houseManage'},
                    {name: '我的故事', path: '/center/myStory'},
                    {name: '金额提现', path: '/center/withdraw'},
                    {name: '我的评价', path: '/center/landlordEvaluate'},
                    {name: '统计数据', path: '/center/statisticsLandord'},
                ],
                driver: [
                    {name: '导游订单', path: '/center/driverOrder'},
                    {name: '接送机管理', path: '/center/shuttleManage'},
                    {name: '路线管理', path: '/center/lineManage'},
                    {name: '前往抢单', path: '/center/robOrder'},
                    {name: '我的故事', path: '/center/myStory'},
                    {name: '金额提现', path: '/center/withdraw'},
                    {name: '我的评价', path: '/center/driverEvaluate'},
                    {name: '统计数据', path: '/center/statisticsDriver'},
                ],
                orderManage: [
                    {name: '我的订单', path: '/center/myOrder'},
                    {name: '评价', path: '/center/myEvaluate'},
                ],
                service: [
                    {name: '意见反馈', path: '/center/feedback'},
                    {name: '联系客服', path: '/center/contactService'},
                    {name: '常见问题', path: '/center/question'},
                    {name: '服务条款', path: '/center/clause'},
                    {name: '关于东瀛民宿', path: '/center/aboutUs'},
                ]
            }
        },
        computed: {
            ...mapState(['userInfo']),
            menuList() {
                let ary = [
                    {name: '用户管理', icon: 'el-icon-user', children: this.userManage},
                    {name: '订单管理', icon: 'el-icon-document', children: this.orderManage},
                ]
                if (this.userInfo.is_landlord > 0) {
                    ary = [
                        ...ary,
                        {name: '房东管理', icon: 'el-icon-user-solid', children: this.landlord}
                    ]
                }
                if (this.userInfo.is_driver > 0) {
                    ary = [
                        ...ary,
                        {name: '导游管理', icon: 'el-icon-s-promotion', children: this.driver}
                    ]
                }
                ary = [
                    ...ary,
                    {name: '服务中心', icon: 'el-icon-service', children: this.service}
                ]
                return ary
            }
        },
        created() {
            this.timeStr = this.getTimeStr();
        },
        mounted() {
            setTimeout(() => {
                app.scrollTop = 0;
            }, 0)
        },
        methods: {
            getTimeStr() {
                let now = new Date();
                let hour = now.getHours();
                if (hour < 12) {
                    return '早上好'
                } else if (hour >= 12 && hour <= 14) {
                    return '中午好'
                } else if (hour > 14 && hour <= 19) {
                    return '下午好'
                } else {
                    return '晚上好'
                }
            }
        },
    }
</script>

<style scoped lang="less">
    .center-head {
        width: 100%;
        height: 180px;
        background: url("./../../assets/img/userB.jpg") 100% 100% no-repeat;
        background-size: cover;

        .center-head-content {
            width: 1200px;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin: auto;

            .user-head {
                width: 100px;
                height: 100px;
                border-radius: 100%;
                margin-right: 20px;
            }

            .nick-name {
                font-size: 22px;
                color: #fff;
                margin: 10px 0;
            }

            .tag-content {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #ffffff;
                font-weight: bold;
            }
        }
    }

    .center-content {
        padding-top: 20px;
        padding-bottom: 20px;
        width: 1200px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        margin: auto;

        .center-menu {
            flex: 1;
            text-align: left;
        }

        .router-view-content {
            width: 960px;
            margin-left: 20px;
        }
    }
</style>
